import {allowScrolling} from "kpcore/kp-util";

class Drawer {
    el = null
    app = null

    constructor(el, app) {
        this.el = el
        this.app = app

        this.app.watchState('isDrawerOpen', isOpen => {
            this.el.classList.toggle('open', isOpen)
            // allowScrolling(!isOpen)
        })

        this.app.watchState('clickedSearchLocationButton', () => {
            if (this.app.getState('isDrawerOpen')) {
                this.app.setState('isDrawerOpen', false)
            }
        })
    }
}

export default Drawer